import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import NumberFormat from 'react-number-format';
import * as productsAction from './actions'
import * as productsConstant from './constants'
import { storedb } from '../client/storedb'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class ProductsEdit extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {},
      formError: {},
      formValid: false,
      stores_id: dbContext.getStoreId(),
      idPrEdit: 0,
      listProductPrice: [{ id: 1, PriceName: 'Giá treo', PriceValue: 0 },{ id: 2, PriceName: 'Giá chia về', PriceValue: 0 }]
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChange = (e) => {
    let { item } = this.state
    if (e.target.name == 'Sku') {
      item[e.target.name] = e.target.value.trim()
    } else {
      item[e.target.name] = e.target.value
    }
    this.setState({ item })
    this.props.productsUpdateError("");

  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    this.props.productsUpdateError("");
    switch (name) {
      case "TrangThai":
        item.IsDeleted = selectedOption.target.value
        break;
      case "NganhHang":
        item.NganhHangId = selectedOption.target.value
        break;
      case "DonViTinh":
        item.DvtId = selectedOption.target.value
        item.DvtTen = selectedOption.target[selectedOption.target.selectedIndex].text
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  handleMoneyChange = (name, data) => {
    let { item } = this.state;
    const value = data.floatValue;
    item[name] = value;
    if (name == "GiaNhap") {
      item["GiaBanSi"] = value;
    }
    this.setState({ item })
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchDetail = () => {
    const { productsDetailRequest } = this.props
    let productId = this.getParam("pid");
    var requestData = {
      ProductId: productId || 0,
      StoreId: this.state.stores_id
    }
    return productsDetailRequest(requestData);
  }
  Updateproducts = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.Ten || this.state.item.Ten == "") {
      formError.Ten = 'Bạn chưa nhập tên sản phẩm';
    }
    if (!this.state.item.Sku || this.state.item.Sku == "") {
      formError.Sku = 'Bạn chưa nhập mã sản phẩm';
    }
    if (this.state.item.IsDeleted == -1) {
      formError.IsDeleted = 'Bạn chưa nhập trạng thái';
    }
    if (!this.state.item.DvtId || this.state.item.DvtId == 0) {
      formError.DvtId = 'Bạn chưa nhập đơn vị tính';
    }
    if (!this.state.item.NganhHangId || this.state.item.NganhHangId == 0) {
      formError.NganhHangId = 'Bạn chưa nhập ngành hàng';
    }
    if (this.state.listProductPrice.length == 0) {
      formError.ListPrice = 'Bạn chưa nhập giá sản phẩm';
    } else {
      let listPrice = this.state.listProductPrice
      for (var index in listPrice) {
        if (listPrice[index].PriceName == '') {
          formError.ListPrice = 'Loại giá và giá trị chưa được nhập';
          break;
        }
      }
    }

    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state;
      item.StoreId = this.state.stores_id;
      item.listProductPrice = this.state.listProductPrice
      this.props.productsUpdateRequest(item);
    }
  }
  BackToListproducts = (item, e) => {
    this.props.history.push('/products');
  }
  handleAddListPrice = () => {
    let listProductPrice = this.state.listProductPrice
    var max = listProductPrice.length == 0 ? 0 : listProductPrice.map(function (d) {
      return d["id"];
    }).reduce(function (p, c, i, arr) {
      return Math.max(p, c);
    });
    listProductPrice.push({ id: max + 1, PriceName: '', PriceValue: 0 })
    this.setState({ listProductPrice })
  }
  handleListPriceChange = (item, id, name, data) => {
    let { listProductPrice } = this.state;
    if (name == 'PriceName') {
      let index = listProductPrice.findIndex(x => x.id === id);
      if (index > -1) {
        listProductPrice[index].PriceName = data.target.value
        this.setState({ listProductPrice });
      }
    } else if (name == 'PriceValue') {
      const floatValue = data.floatValue;
      // if (floatValue > 0) {
        let index = listProductPrice.findIndex(x => x.id === id);
        if (index > -1) {
          listProductPrice[index].PriceValue = floatValue
          this.setState({ listProductPrice });
        }
      // }
    }
  }
  handleRemoveListProductPrice = (e, id) => {
    let { listProductPrice } = this.state;
    let index = listProductPrice.findIndex(x => x.id === id);
    if (index > -1) {
      listProductPrice.splice(index, 1);
      this.setState({ listProductPrice })
    }
  }
  componentDidMount() {
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.productsEdit.type == productsConstant.PRODUCTS_DETAIL_SUCCESS) {
      let { item, listPrice } = nextProps.productsEdit;
      if (item.ProductId && item.ProductId > 0) {
        item.IsDeleted = item.IsDeleted || 0
        this.setState({
          item,
          idPrEdit: item.ProductId,
          listProductPrice: listPrice.length > 0 ? listPrice : this.state.listProductPrice
        });
      } else {
        item["IsDeleted"] = 0;
        this.setState({ item })
      }
    } else if (nextProps.productsEdit.type == productsConstant.PRODUCTS_UPDATE_SUCCESS) {
      this.props.history.push("/products");
    }
  }
  render() {
    const { formError, item, idPrEdit, listProductPrice } = this.state;
    const {
      handleSubmit,
      productsEdit: {
        isRequesting,
        errors,
        messages,
        listDvt,
        listNganhHang
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={false} >
          <div className="row">
            <FormGroup className="col-sm-4">
              <Label >Mã sản phẩm(*)</Label>
              <Input type="text" name="Sku" placeholder="Mã sản phẩm" value={item.Sku || ''} readOnly={idPrEdit > 0 ? true : false} onChange={this.handleControlChange.bind(this)} autoComplete="off" />
              <em className="error invalid-feedback">{formError.Sku}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Tên sản phẩm(*)</Label>
              <Input type="text" name="Ten" placeholder="Tên sản phẩm" value={item.Ten || ''} onChange={this.handleControlChange.bind(this)} autoComplete="off" />
              <em className="error invalid-feedback">{formError.Ten}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Nhóm hàng</Label>
              <select name="NganhHangId" className="form-control" value={item.NganhHangId} onChange={this.handleSelectChange.bind(this, "NganhHang")}>
                <option value={0}>--Nhóm hàng--</option>
                {
                  listNganhHang && !!listNganhHang.length && listNganhHang.map(option => {
                    return (
                      <option value={option.NganhHangId} key={option.NganhHangId}> {option.Ten}</option>
                    )
                  })
                }
              </select>
              <em className="error invalid-feedback">{formError.NganhHangId}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Đơn vị tính(*)</Label>
              <select name="DvtId" className="form-control" value={item.DvtId} onChange={this.handleSelectChange.bind(this, "DonViTinh")}>
                <option value={0}>--Đơn vị tính--</option>
                {
                  listDvt && !!listDvt.length && listDvt.map(option => {
                    return (
                      <option value={option.DvtId} key={option.DvtId}> {option.Ten}</option>
                    )
                  })
                }
              </select>
              <em className="error invalid-feedback">{formError.DvtId}</em>
            </FormGroup>
            <FormGroup className="col-sm-2">
              <Label >Điểm thưởng</Label>
              <NumberFormat
                name={"Diem"}
                value={item.Diem}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "Diem")}
                className={"form-control order-input-price price"} autoComplete="off" />
            </FormGroup>
            <FormGroup className="col-sm-2">
              <Label >VAT</Label>
              <NumberFormat
                name={"Vat"}
                value={item.Vat}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "Vat")}
                className={"form-control order-input-price price"} autoComplete="off" />
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Quy cách đóng gói</Label>
              <Input type="text" name="QuyCachDongGoi" placeholder="Quy cách đóng gói" value={item.QuyCachDongGoi || ''} onChange={this.handleControlChange.bind(this)} autoComplete="off" />
            </FormGroup>
            {/* <FormGroup className="col-sm-4">
              <Label>Quy cách</Label>
              <NumberFormat
                name={"QuyCach"}
                value={item.QuyCach}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "QuyCach")}
                className={"form-control order-input-price price"} autoComplete="off" />
              <em className="error invalid-feedback">{formError.DienThoai}</em>
            </FormGroup> */}
            <FormGroup className="col-sm-4">
              <Label >Số ĐK</Label>
              <Input type="text" name="SoDangKy" placeholder="Số ĐK" value={item.SoDangKy || ''} onChange={this.handleControlChange.bind(this)} />
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Trạng thái(*)</Label>
              <select name="IsDeleted" className="form-control" value={item.IsDeleted} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                <option value={-1}>--Trạng thái--</option>
                <option value={0}>Hoạt động</option>
                <option value={1}>Ngừng hoạt động</option>
              </select>
              <em className="error invalid-feedback">{formError.IsDeleted}</em>
            </FormGroup>
            {/* <FormGroup className="col-sm-4">
              <Label >Nước sản xuất</Label>
              <Input type="text" name="NuocSX" placeholder="Nước sản xuất" value={item.NuocSX || ''} onChange={this.handleControlChange.bind(this)} />
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Hãng sản xuất</Label>
              <Input type="text" name="HangSX" placeholder="Hãng sản xuất" value={item.HangSX || ''} onChange={this.handleControlChange.bind(this)} />
            </FormGroup> */}
            <FormGroup className="col-sm-4">
              <Label >Giá nhập</Label>
              <NumberFormat
                name={"GiaNhap"}
                value={item.GiaNhap}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "GiaNhap")}
                className={"form-control order-input-price price"} autoComplete="off" />
              <em className="error invalid-feedback">{formError.GiaNhap}</em>
            </FormGroup>
            {/* <FormGroup className="col-sm-4">
              <Label >Giá Lương NV</Label>
              <NumberFormat
                name={"GiaTinhLuong"}
                value={item.GiaTinhLuong}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "GiaTinhLuong")}
                className={"form-control order-input-price price"} autoComplete="off" />
            </FormGroup> */}
            {/* <FormGroup className="col-sm-4">
              <Label >Giá Bán</Label>
              <NumberFormat
                name={"GiaBanLe"}
                value={item.GiaBanLe}
                defaultValue={0}
                thousandSeparator={"."}
                decimalSeparator={","}
                type="tel"
                onClick={this.numberOnclick.bind(this)}
                onValueChange={this.handleMoneyChange.bind(this, "GiaBanLe")}
                className={"form-control order-input-price price"} autoComplete="off" />
            </FormGroup> */}
            <FormGroup className="col-sm-12">
              <div>
                <em className="error invalid-feedback">{formError.ListPrice}</em>
                <table className="table-bordered w-100">
                  <thead className="thead-default">
                    <tr>
                      <th scope="col" width="50" className="text-center">
                        <a onClick={this.handleAddListPrice} className="btn-sm btn btn-primary">Thêm</a>
                      </th>
                      <th scope="col" className="text-center">Loại giá bán</th>
                      <th scope="col" className="text-center">Giá tiền</th>
                      <th scope="col" width="20" className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {listProductPrice && !!listProductPrice.length && (
                      listProductPrice.map((res, idx) => (
                        <tr key={(idx + 1)}>
                          <td className="text-center">{(idx + 1)}</td>
                          <td className="text-left input-group-sm">
                            <Input type="text" name="PriceName" placeholder="Tên giá" value={res.PriceName || ''} onChange={this.handleListPriceChange.bind(this, res, res.id, "PriceName")} />
                          </td>
                          <td className="text-left input-group-sm">
                            <NumberFormat
                              name={"PriceValue"}
                              value={res.PriceValue || 0}
                              defaultValue={0}
                              thousandSeparator={"."}
                              decimalSeparator={","}
                              maxLength={10}
                              type="tel"
                              placeholder="Giá tiền"
                              onClick={this.numberOnclick.bind(this)}
                              onValueChange={this.handleListPriceChange.bind(this, res, res.id, "PriceValue")}
                              className={"form-control order-input-sl price"}
                              autoComplete="off"
                            />
                          </td>
                          <td className="text-center">
                            <a className="text-danger" onClick={e => this.handleRemoveListProductPrice(e, res.id)} ><i className="fa fa-trash-o fa-lg"></i></a>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <em className="error invalid-feedback">{formError.ListPrice}</em>
              </div>
            </FormGroup>
            <FormGroup className="col-sm-12">
              <Label>Ghi chú</Label>
              <Input type="textarea" name="GhiChu" className="form-control" value={item.GhiChu || ''} onChange={this.handleControlChange.bind(this)} autoComplete="off" />
            </FormGroup>
          </div>
          <div className="w-100 mb-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Danh sách"
              btnClick={() => this.BackToListproducts()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.Updateproducts()}
              permission={BtnPermissions.SanPham.ADD_OR_UPDATE} />
          </div>
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  productsEdit: state.productsEdit,
})
const connected = connect(mapStateToProps, {
  productsDetailRequest: productsAction.productsDetailRequest,
  productsUpdateRequest: productsAction.productsUpdateRequest,
  productsListRequest: productsAction.productsListRequest,
  productsUpdateError: productsAction.productsUpdateError,
})(ProductsEdit)

const formed = reduxForm({
  form: 'productsEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/Products/ProductsEdit.js